module.exports = __webpack_public_path__ + "fonts/memnYaGs126MiZpBA-UFUKW-U9hrIqM.c62c3eea.woff2";